import React from 'react'
import loading from '../assets/loading.gif'

function Spinner() {
    return <img src={loading} alt='loading...' style={{display:'block',margin:'auto',}} />


}

export default Spinner